import { bff } from '@/lib/http/bff';

export type OutcomeValueKind = 'int' | 'float' | 'string' | 'bool' | 'jsonb' | 'timestamp';

export interface OutcomeDefinition {
  handler_key: string;
  id_category: number;
  id_type: number;
  key: string;
  value_kind: OutcomeValueKind;
  description: string;
}

export type OutcomeDefinitionsV2Response = {
  global: OutcomeDefinition[];
  run: OutcomeDefinition[];
  handler_scoped: Array<{ handler_key_base: string; definitions: OutcomeDefinition[] }>;
  totals?: {
    global: number;
    run: number;
    handler_scoped: number;
    handler_groups: number;
  };
};

export const fetchOutcomeDefinitionsApi = (handlerKey?: string): Promise<OutcomeDefinition[]> =>
  bff.get<OutcomeDefinition[]>('/orchestrator/outcome-definitions', {
    handler_key: handlerKey,
  });

export const fetchOutcomeDefinitionsV2Api = (): Promise<OutcomeDefinitionsV2Response> =>
  bff.get<OutcomeDefinitionsV2Response>('/orchestrator/outcome-definitions/v2');

export type UpsertOutcomeDefinitionsRequest = {
  // Supports the orchestrator payload shape: { definitions: [...] }
  definitions: Array<{
    handler_key?: string;
    id_category: number;
    id_type: number;
    key: string;
    value_kind: OutcomeValueKind;
    description: string;
  }>;
};

export type UpsertOutcomeDefinitionsResponse = {
  upserted: number;
};

export const upsertOutcomeDefinitionsApi = (payload: UpsertOutcomeDefinitionsRequest) =>
  bff.post<UpsertOutcomeDefinitionsResponse, UpsertOutcomeDefinitionsRequest>(
    '/orchestrator/outcome-definitions',
    payload
  );

// Replace mode: payload is treated as the authoritative set of definitions for the handler keys present.
// Used to keep handler IO contract and outcome registry in sync (including removals).
export const replaceOutcomeDefinitionsApi = (payload: UpsertOutcomeDefinitionsRequest) =>
  bff.post<UpsertOutcomeDefinitionsResponse, UpsertOutcomeDefinitionsRequest>(
    '/orchestrator/outcome-definitions/replace',
    payload
  );

export type DeleteOutcomeDefinitionResponse = {
  deleted: boolean;
  handler_key: string;
  key: string;
};

export const deleteOutcomeDefinitionApi = (handlerKey: string, key: string) => {
  const qs = new URLSearchParams({ handler_key: handlerKey, key });
  return bff.del<DeleteOutcomeDefinitionResponse>(`/orchestrator/outcome-definitions?${qs.toString()}`);
};
